export default __webpack_public_path__ + "static/media/home_carousel_7.e4e9db60.png";